import React, { ReactNode } from 'react';
// import { BrowserRouter as Router } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { ClerkProvider } from '@clerk/clerk-react';
import { jaJP } from '@clerk/localizations';
import * as Sentry from '@sentry/react';

import { DepartmentProvider } from '@/entities/department'; // ★ FSD パス
// import { QueryClientProvider } from '@tanstack/react-query'; // TanStack Query 導入時
// import { queryClient } from '@/shared/lib/queryClient'; // TanStack Query 導入時
import { ErrorFallback } from '@/shared/ui/error-fallback'; // カスタムエラーフォールバック

interface AppProviderProps {
  children: ReactNode;
}

// Clerk の Publishable Key を環境変数から取得
const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!publishableKey) {
  // アプリケーション起動前にエラーを投げる
  throw new Error(
    'Missing Clerk Publishable Key. Set REACT_APP_CLERK_PUBLISHABLE_KEY environment variable.'
  );
}

// ClerkProvider をラップするコンポーネント
const ClerkProviderWithRouter: React.FC<{
  children: ReactNode;
  publishableKey: string;
}> = ({ children, publishableKey }) => {
  const navigate = useNavigate();

  return (
    <ClerkProvider
      publishableKey={publishableKey}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      afterSignOutUrl="/"
      localization={jaJP}
      touchSession={true} // セッションのポーリングを無効化 (必要に応じて調整)
    >
      {children}
    </ClerkProvider>
  );
};

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  return (
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<ErrorFallback error={null} />}>
        <ClerkProviderWithRouter publishableKey={publishableKey}>
          <DepartmentProvider>{children}</DepartmentProvider>
        </ClerkProviderWithRouter>
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  );
};
